import httpClient from './httpClient';

const END_POINT = '/api/organisation';

const addOrganisation = (organisation, packCountryDomain, price, decimalDigits, currency, isPayed, tva) =>
    httpClient.post(END_POINT + '/add', {
        organisation, packCountryDomain, price, decimalDigits, currency, isPayed, tva
    });
const editOrganisation = (
    id, name, address, country, postalCode, city, additionalAddress, numSiret, phone, phoneNumberCode, taxRegistrationNumber, website, timezone
) =>
    httpClient.put(END_POINT + 's/' + id, {
        name,
        address,
        country,
        postalCode,
        city,
        additionalAddress,
        numSiret,
        phone,
        phoneNumberCode,
        taxRegistrationNumber,
        website,
        timezone
    });
const deleteOrganisation = idOrganisation =>
    httpClient.post(END_POINT + 's/delete', {idOrganisation});
export {
    addOrganisation,
    editOrganisation,
    deleteOrganisation
};
